import { Injectable } from '@angular/core';
import { ListType } from 'app/types';

@Injectable()
export class ListService {
  public listTypes: Array<any>;
  public listModel: any;
  public maxFileSize: number;

  constructor() {
    this.listTypes = [
      { id: ListType.IP_ADDRESSES, name: 'IP_ADDRESSES', active: true, maxFileSize: 15 },
      { id: ListType.IPV6_RANGES, name: 'IPV6_RANGES', active: false, maxFileSize: 15 },
      { id: ListType.APPLE_ADVERTISING_ID, name: 'APPLE_ADVERTISING_ID', active: false, maxFileSize: 15 },
      { id: ListType.GOOGLE_ADVERTISING_ID, name: 'GOOGLE_ADVERTISING_ID', active: false, maxFileSize: 15 },
      { id: ListType.BUNDLES_DOMAINS, name: 'BUNDLES_DOMAINS', active: true, maxFileSize: 10 },
      { id: ListType.URL_ADDRESSES, name: 'URL_ADDRESSES', active: true, maxFileSize: 15 },
      { id: ListType.SCHAIN, name: 'SCHAIN', active: true, maxFileSize: 31 },
    ];
    this.listModel = {
      name: '',
      conditionType: 1,
      listType: ListType.BUNDLES_DOMAINS,
      effectiveForAll: false,
      numberOfItems: 0,
    };
    this.maxFileSize = 15;
  }
}
